import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Reviews, IconReviewStar, Button, IconCollection } from '../';
import css from './StoreReviews.module.css';

const StoreReviews = ({ reviews, averageRating, totalReviews, title }) => {
    // Only render if required details are present
    if (!Array.isArray(reviews) || reviews.length === 0 || !averageRating || !totalReviews) return null;

    const [visibleCount, setVisibleCount] = useState(3);
    const showMore = visibleCount < reviews.length;

    return (
        <div className={css.root}>
            <div className={css.headerRow}>
                <h4 className={css.title}>Owner Reviews</h4>
                <div className={css.summary}>
                    <svg className={css.starIcon} xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24" fill="none">
                        <g clip-path="url(#clip0_4291_25276)">
                            <path d="M11.5383 1.71006C11.7091 1.29942 12.2909 1.29942 12.4617 1.71006L15.0568 7.94943C15.1288 8.12254 15.2916 8.24083 15.4785 8.25581L22.2144 8.79583C22.6577 8.83137 22.8375 9.38462 22.4997 9.67396L17.3676 14.0701C17.2252 14.1921 17.1631 14.3835 17.2066 14.5659L18.7745 21.139C18.8777 21.5716 18.4071 21.9135 18.0275 21.6817L12.2606 18.1593C12.1006 18.0616 11.8994 18.0616 11.7394 18.1593L5.97249 21.6817C5.59294 21.9135 5.12231 21.5716 5.22551 21.139L6.79344 14.5659C6.83694 14.3835 6.77475 14.1921 6.63236 14.0701L1.5003 9.67396C1.16253 9.38462 1.34229 8.83137 1.78562 8.79583L8.52154 8.25581C8.70843 8.24083 8.87124 8.12254 8.94324 7.94943L11.5383 1.71006Z" fill="#FDB022" />
                        </g>
                        <defs>
                            <clipPath id="clip0_4291_25276">
                                <rect width="18" height="24" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    <span className={css.rating}>{averageRating.toFixed(1)}</span>
                    <span className={css.reviewCount}>({totalReviews} reviews)</span>
                </div>
            </div>
            <div className={css.reviewsList}>
                <Reviews reviews={reviews.slice(0, visibleCount)} rootClassName={css.reviews} />
            </div>
            {showMore && (
                <div className={css.moreBtnRow}>
                    <Button variant="info" arrow='right' icon={<IconCollection name="arrow_righ_stright" />} className={css.moreBtn} onClick={() => setVisibleCount(visibleCount + 3)}>
                        Read more reviews
                    </Button>
                </div>
            )}
        </div>
    );
};

StoreReviews.propTypes = {
    reviews: PropTypes.array.isRequired,
    averageRating: PropTypes.number.isRequired,
    totalReviews: PropTypes.number.isRequired,
    title: PropTypes.string,
};

export default StoreReviews; 